import React, { useEffect, useState } from 'react';
import '../../styles/Blog.css';
import { Plus, Pencil } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/Card';

import { useNavigate, Link  } from 'react-router-dom';

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [viewMode, setViewMode] = useState('published'); // 'published' or 'drafts'
  const navigate = useNavigate();

  function isBlogAdmin() {
    try {
      const groups = JSON.parse(sessionStorage.getItem('CognitoUserGroups') || '[]');
      return groups.includes('blog-admin');
    } catch {
      return false;
    }
  }

  useEffect(() => {
    const fetchPosts = async () => {
      const apiUrl = 'https://i0nzyjj5hc.execute-api.us-east-1.amazonaws.com/prod/posts';
      try {
        const response = await fetch(apiUrl, { mode: 'cors' });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
        let data;
        try { data = await response.json(); } catch (jsonErr) { throw jsonErr; }
        let blogArray = [];
        if (data && Array.isArray(data.data)) blogArray = data.data;
        else if (Array.isArray(data)) blogArray = data;
        
        // Filter based on view mode and admin status
        let filteredPosts;
        if (viewMode === 'drafts' && isBlogAdmin()) {
          filteredPosts = blogArray.filter(post => post.status === 'DRAFT');
        } else {
          filteredPosts = blogArray.filter(post => post.status === 'PUBLISHED');
        }
        
        const sortedPosts = filteredPosts.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setPosts(sortedPosts);
        setError(null);
      } catch (err) {
        setPosts([]);
        setError(err.message || 'Unknown error occurred while fetching posts.');
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, [viewMode]); // Re-fetch when view mode changes

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#fafafa' }}>
      <main className="blog-main-content">
        <div className="blog-header-bar">
          <h1 className="blog-title">Skroop Blog</h1>
          
          {isBlogAdmin() && (
            <div className="admin-controls">
              <div className="view-toggle">
                <button 
                  className={viewMode === 'published' ? 'active' : ''}
                  onClick={() => setViewMode('published')}
                >
                  Published
                </button>
                <button 
                  className={viewMode === 'drafts' ? 'active' : ''}
                  onClick={() => setViewMode('drafts')}
                >
                  Drafts
                </button>
              </div>
              <button className="new-post-btn" onClick={() => navigate('/dashboard/blog/edit')}>
                <Plus size={18} style={{ marginRight: '8px' }} /> New Post
              </button>
            </div>
          )}
        </div>
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p className="text-red-500">Error: {error}</p>
        ) : Array.isArray(posts) && posts.length > 0 ? (
          <div className="blog-posts-grid">
            {posts.map(post => (
              <Card key={post.id} className="blog-card" onClick={() => navigate(`/dashboard/blog/${encodeURIComponent(post.slug)}`)} style={{ cursor: 'pointer' }}>
                <img
                  src={post.heroImageUrl || '/images/blog-default.jpg'}
                  alt={post.title}
                  onError={e => { e.target.src = '/images/blog-default.jpg'; }}
                />
                {isBlogAdmin() && (
                  <div className="card-actions">
                    <button
                      className="edit-post-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/dashboard/blog/edit/${post.id}`);
                      }}
                      title="Edit Post"
                    >
                      <Pencil size={16} style={{ marginRight: '6px' }} /> Edit Post
                    </button>
                  </div>
                )}
                <CardContent className="blog-content">
                  <div className="text-gray-500 text-sm mb-1">
                    <span>{new Date(post.updatedAt).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}</span>
                  </div>
                  <h2>{post.title || 'Untitled Post'}</h2>
                  <p className="blog-summary">{post.excerpt || ''}</p>


                </CardContent>
              </Card>
            ))}
          </div>
        ) : (
          <div>No posts found.</div>
        )}
      </main>
    </div>
  );
};

export default Blog;
